import isEmpty from 'lodash/isEmpty';

export default class SignUpRedirectHelper {
  constructor(customerData) {
    this.customerData = customerData;
    this.accountCreatedAlready = false;
  }

  getRedirectPath() {
    var cd = this.customerData;

    if (this.accountCreatedAlready) {
      return 'routes.url.booking';
    }

    if (isEmpty(cd.email) || isEmpty(cd.name)) {
      return 'routes.url.registrationStep1';
    } else {
      return 'routes.url.registrationStep2';
    }

  }
}
